import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './LinkValue.css';

const LinkValue = ({ valueLinkText, valueLinkUrl }) => (
  <div className='ui fluid input'>
    <div className='link-value__input'>
      {valueLinkText} <Link to={valueLinkUrl} className='link-value__link'>here</Link>
    </div>
  </div>
);

LinkValue.propTypes = {
  valueLinkText: PropTypes.string.isRequired,
  valueLinkUrl: PropTypes.string.isRequired,
};

export default LinkValue;
